declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const pushUserDataToGTM = async (email: string) => {
  window.dataLayer = window.dataLayer || [];

  const encoder = new TextEncoder();
  const data = encoder.encode(email);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  window.dataLayer.push({
    event: "userData",
    userEmail: hashHex,
    timestamp: new Date().toISOString(),
  });
};
